<template>
  <div>
    <div class="modal show fade modal text-left " style="display: block;" v-if="show">
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content" style="min-height: 500px">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Onboard PFAC With New Switch
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12 d-flex mt-2  justify-content-center" v-if="loader">
              <div class="spinner-border text-primary"></div>
            </div>
            <form class="validate-form mt-2"  v-if="!loader">
              <div class="row">
                <div class="col-12 ">
                  <div class="form-group">
                    <label for="account-name">Select Switch</label>
                    <multiselect
                        v-model="selectedSwitch"
                        :options="switchList"
                        label="label"
                        track-by="id"
                        placeholder="Select Switch"
                        variant="primary"
                        :custom-label="customNameForMultiselect"
                    ></multiselect>
                  </div>
                </div>
              </div>
            </form>
            <form class="validate-form mt-2" v-if="!loader">
              <div class="row">
                <!-- Dynamically generate fields -->
                <div v-for="(field, index) in mergedFields" :key="index" class="col-md-6">
                  <div class="form-group">
                    <label :for="field.name">{{ field.title }}</label>
                    <!-- Text Input -->
                    <input
                        v-if="field.type === 'text' || field.Type === 'text'"
                        type="text"
                        class="form-control"
                        :id="field.name"
                        v-model="formData[field.name]"
                        v-validate="field.required ? 'required' : ''"
                        :name="field.name"
                        :class="errorBag.has(field.name) ? 'is-invalid' : ''"
                        :placeholder="field.title"
                    />
                    <!-- Dropdown Input -->
                    <select
                        v-if="field.type === 'dropDown'"
                        class="form-control"
                        :id="field.name"
                        v-model="formData[field.name]"
                        v-validate="field.required ? 'required' : ''"
                        :name="field.name"
                        :class="errorBag.has(field.name) ? 'is-invalid' : ''"
                    >
                      <option :value="null" disabled selected>Select {{ field.title }}</option>
                      <option v-for="option in field.options" :key="option" :value="option">{{ option }}</option>
                    </select>

                    <multiselect
                        v-if="field.type === 'multipleDropDown'"
                        v-model="formData[field.name]"
                        :options="field.options"
                        :multiple="true"
                        class="shorten-multiselect-option"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :placeholder="'Select ' + field.title"
                        v-validate="field.required ? 'required' : ''"
                        :name="field.name"
                        :class="errorBag.has(field.name) ? 'is-invalid' : ''"
                    ></multiselect>
                    <small
                        v-show="errorBag.has(field.name)"
                        class="invalid-feedback"
                    >
                      {{ "*" + errorBag.first(field.name) }}
                    </small>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer justify-content-center">
            <button
                type="button"
                class="btn btn-primary mr-1 d-flex"
                @click="sendCall"
                :disabled="loading"
            >
              <Loader :loading="loading" :size="size"></Loader>
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ['show', 'data'],
  mounted() {

  },
  data() {
    return {
      loader: false,
      size: "10px",
      merchantId: '',
      imei: '',
      loading: false,
      url: "assign-pos-device-to-channel",
      switchList: [],
      selectedSwitch: '',
      formData: {},
      mergedFields: [],
    };
  },
  methods: {
    getSwitches(){
      let requestData = {
        paymentSwitches: 1,
      }
      this.makeRequest("post", "v1/get-charges-types-data", requestData, {}, false).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = []
                data = callResponse.response.data.data;
                if(data?.paymentSwitches){
                  this.switchList = data.paymentSwitches
                }

              }
            }
          }
      );
    },
    customNameForMultiselect(val) {
      return val.name
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = {
            merchantId: this. merchantId,
            switchId: this.selectedSwitch?.id,
            switchData: JSON.stringify(this.formData)
          }

          this.makeRequest("post", 'v1/onboard-merchant-switch-pfac', data).then(callResponse => {
            this.loading = false;
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                this.$emit('switchAdded')
              }
            }
          });
        }
      });
    }
  },
  watch: {
    show(val) {
      if(val){
        if(this.data){
          this.merchantId = this.data.merchantId
        }
        this.getSwitches()
      }else{
        this.selectedSwitch = null
      }
    },
    selectedSwitch(val) {
      this.mergedFields = []
      if (val) {
        const fieldsData = JSON.parse(val?.fieldsData || "{}");
        this.mergedFields = [
          ...(fieldsData.commonFieldSet || []),
          ...(fieldsData.pfacFieldsDataSet || [])
        ];

        // Initialize formData with default values
        this.mergedFields.forEach(field => {
          this.$set(this.formData, field.name, field.value || "");
        });
      }
    }
  }
};
</script>

<style scoped>
.modal {
  display: block !important;
  /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  overflow-y: auto;
}
</style>
